var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topbar-comp'),_c('left-bar-comp',[_c('sports-left-bar-comp')],1),_c('right-bar-comp',[_c('right-bar-banner-comp',{attrs:{"slot":"rightBanner"},slot:"rightBanner"})],1),_c('foot-comp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }